/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserMini,
    ElementsUserMiniFromJSON,
    ElementsUserMiniFromJSONTyped,
    ElementsUserMiniToJSON,
    StorageNodeMini,
    StorageNodeMiniFromJSON,
    StorageNodeMiniFromJSONTyped,
    StorageNodeMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface Alert
 */
export interface Alert {
    /**
     * 
     * @type {number}
     * @memberof Alert
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    level: string;
    /**
     * 
     * @type {boolean}
     * @memberof Alert
     */
    isOpen: boolean;
    /**
     * 
     * @type {StorageNodeMini}
     * @memberof Alert
     */
    node: StorageNodeMini | null;
    /**
     * 
     * @type {Date}
     * @memberof Alert
     */
    readonly openedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Alert
     */
    readonly closedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    readonly duration: string;
    /**
     * 
     * @type {ElementsUserMini}
     * @memberof Alert
     */
    acknowledgedBy: ElementsUserMini;
}

export function AlertFromJSON(json: any): Alert {
    return AlertFromJSONTyped(json, false);
}

export function AlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): Alert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'message': json['message'],
        'level': json['level'],
        'isOpen': json['is_open'],
        'node': StorageNodeMiniFromJSON(json['node']),
        'openedAt': (new Date(json['opened_at'])),
        'closedAt': !exists(json, 'closed_at') ? undefined : (json['closed_at'] === null ? null : new Date(json['closed_at'])),
        'duration': json['duration'],
        'acknowledgedBy': ElementsUserMiniFromJSON(json['acknowledged_by']),
    };
}

export function AlertToJSON(value?: Alert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'message': value.message,
        'level': value.level,
        'is_open': value.isOpen,
        'node': StorageNodeMiniToJSON(value.node),
        'acknowledged_by': ElementsUserMiniToJSON(value.acknowledgedBy),
    };
}


